import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import './Updates.css';

const Updates_3_49_0 = () => {
  return (
    <div>
      <PageTitle title='3.49.0' />

      <ParaTitle paraTitle='Simpler UI & Better Reporting' />
      <Paragraph paragraph='2026-03-02' />

      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          Anonymous Reporting
          <p>Provide clear visibility into anonymous submissions, including event locations, the number of events marked “Prefer not to answer,” and a comparison against events where reporter information was disclosed.</p>
        </li>
        {/* <li>
          <p></p>
        </li> */}
      </ul>

      {/* <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>
          <p></p>
        </li>
      </ul> */}

      <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>
          Remove Personal Notes and Messages
          <p>These features have seen minimal usage and have been removed to streamline the interface and improve overall usability.</p>
        </li>
      </ul>
      <Pagination
        pagination={{
          prev: { name: 'Home', link: '/' },
          next: { name: 'Updates: 3.48.0', link: '/updates/3.48.0' }
        }}
      />
    </div>

  )
}

export default Updates_3_49_0;